import React, {Component} from "react";

import classes from "./styles..module.scss";
import HeadLine from "../../components/Atoms/HeadLine";
import Head from "next/head";

const createMarkup = content => ({__html: content});

class Delivery extends Component {
    render() {
        const {t, delivery} = this.props;
        return (
            <section className={classes.page}>
                <Head>
                    <title>{`Deliver | univermag.com`}</title>
                    <meta property="og:title" content="Deliver" />
                </Head>
                <HeadLine label={`${t("title")}`}/>
                <div
                    className="content"
                    dangerouslySetInnerHTML={createMarkup(delivery.content)}
                />
            </section>
        );
    }
}

export default Delivery;
